let activeId = null;
let saveHandler = null;
let discardHandler = null;

export function registerWizard({ id, save, discard }) {
  activeId = id ?? null;
  saveHandler = typeof save === "function" ? save : null;
  discardHandler = typeof discard === "function" ? discard : null;
}

export function unregisterWizard() {
  activeId = null;
  saveHandler = null;
  discardHandler = null;
}

export function isWizardActive() {
  return !!activeId;
}

export function saveCurrentWizard() {
  if (saveHandler) saveHandler();
}

export function discardCurrentWizard() {
  if (discardHandler) discardHandler();
}
